import React, { Component } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  faAngleDown,
  faStopCircle,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Menu, Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import colors from "../../colors";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var moment = require("moment");



library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);
// let clickcount=0
export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      margin: props.margin,
      selected: false,
      color: props.color,
      prevColor: props.color,
    };
  }
/** Main Tab Click */
  onClick = () => {
    console.log(this.props.clickcount);

    if (this.props.clickcount === 0) {
      this.props.incrementCounter();
    } else {
      this.props.incrementCounter();
      this.props.handleTabClick(this.props.data.id);
    }

    console.log(this.props.data.name);
    if (this.props.data.name === "Forecast Surface Runoff") {
      this.props.getAvailableDates_url();
    }
    else this.props.getAvailableDates_date();

  };
/** Map Item Click */
  onClickChild = () => {

    let menu = this.props.parent
      ? this.props.parent + "-" + this.props.data.name
      : this.props.data.name;
    console.log(menu);
    console.log(this.props.isForecast);
    console.log(this.props.data.disabledate);
    this.props.menuSelected(menu);
    if (this.props.data.ismap && this.props.selectedMenu !== menu) {
      console.log(menu);
      this.props.toggleSelectedNodeStatus(menu);
      this.props.setSelectedMenu(menu);
      this.props.setSelectedLayer(menu);
      // this.props.setNoGraph(menu, this.props.noGraph ? true : false);
      // this.props.setNoGraph(menu, this.props.data.noGraph ? true : false);
      // this.props.disableDatePicker(false);
      // this.props.setPopupMenuStatusOnMapMenuClick();
      // console.log(this.props.popupMenuSelectedLast);
      // this.props.togglePopupMenuSelected(this.props.popupMenuSelectedLast);
    }
    if (this.props.data.geojson) {
      console.log('treenode geojson')
      this.props.toggleSelectedNodeStatus(menu);
      this.props.setSelectedMenu(menu);
      this.props.setGeoJson(menu);
    }
    if (this.props.data.disabledate) {
      this.props.disableDatePicker(true);
    }
    if (this.props.isForecast) {
      console.log(this.props.isForecast);
      let date = moment(this.props.date, "DD MMMM YYYY")
        .add(this.props.data.name, "days")
        .format("DD MMMM YYYY");
      this.props.setForecastDate(date);
      // this.props.toggleSelectedNodeStatus(menu);
      // this.props.setSelectedMenu(menu);
      // this.props.setSelectedLayer(menu);
    }
    
    if (this.props.weekly || this.props.monthly) {
      this.props.toggleSelectedNodeStatus(menu);
      this.props.setSelectedMenu(menu);
      this.props.setSelectedLayer(menu);
    }
    
    if (this.props.data.popup) {
      console.log(menu);
      this.props.setPopupMenuSelectedLast(menu);
      this.props.setPopupMenuSelectedStatus();
      this.props.togglePopupMenuSelected(menu);
      // this.props.history.push(`/webgis-vic/map/${menu.split(' ').join('-').toLowerCase()}`)
    }
    // this.props.data.ismap?this.props.setSelectedLayer(this.props.data.name,this.props.data.defaultLayer):null
  };


/** OnLoading into DOM  */

  componentDidMount() {
    console.log(this.props.data)
    if (this.props.data.hasDefault) {
      this.onClick();
    }
    if (
      this.props.selectedLayerLink === this.props.data.name ||
      this.props.data.default
    ) {
      this.onClickChild();
    }
    this.props.incrementCounter();

    if (this.props.data.active) {
      this.onClick();
      this.onClickChild();
    }

  }

  render() {
    console.log(this.props);
    const { date, availableDates, handleDateChange } = this.props;

    // Convert available dates (if any) to Date objects for `react-datepicker`
    const enabledDates = availableDates.map((momentDate) => momentDate.toDate());
    let weeks, months, monthYears, years
    if (this.props.weeks) {
      weeks = this.props.weeks.map((item) => {
        return (<option value={item.week}>{item.week}</option>)
      })
    }
    if (this.props.months) {
      months = this.props.months.map((item) => {
        return (<option value={item.month}>{item.month}</option>)
      })
    }
    if (this.props.weekyears) {
      years = this.props.weekyears.map((item) => {
        return (<option value={item.year}>{item.year}</option>)
      })
    }
    if (this.props.monthyears) {
      monthYears = this.props.monthyears.map((item) => {
        return (<option value={item.year}>{item.year}</option>)
      })
    }

    let subtree = null;
    if (this.props.data.children) {
      subtree = this.props.data.children.map((child, key) => {
        return (
          <TreeNode
            weekyears={this.props.weekyears}
            weeks={this.props.weeks}
            weekselected={this.props.weekselected}
            weekChange={this.props.weekChange}
            weekyearselected={this.props.weekyearselected}
            weekYearChange={this.props.weekYearChange}

            monthyears={this.props.monthyears}
            months={this.props.months}
            monthselected={this.props.monthselected}
            monthChange={this.props.monthChange}
            monthyearselected={this.props.monthyearselected}
            monthYearChange={this.props.monthYearChange}
            
            key={key}
            data={child}
            // id={this.props.id}
            clickcount={this.props.clickcount}
            incrementCounter={this.props.incrementCounter}
            active={this.props.active}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            margin={this.state.margin + 5}
            color={this.state.color}
            date={this.props.date}
            availableDates={this.props.availableDates}
            handleDateChange={this.props.handleDateChange}
            getAvailableDates={this.props.getAvailableDates}
            getAvailableDates_url={this.props.getAvailableDates_url}
            menuSelected={this.props.menuSelected}
            selectedLayerLink={this.props.selectedLayerLink}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStaus={this.props.selectedNodeStaus}
            setPopupMenuSelectedLast={this.props.setPopupMenuSelectedLast}
            popupMenuSelectedLast={this.props.popupMenuSelectedLast}
            parent={this.props.data.name}
            getAvailableDates_date={this.props.getAvailableDates_date}
            isForecast={this.props.data.forecast}
            // weekly={this.props}
            setForecastDate={this.props.setForecastDate}
            setGeoJson={this.props.setGeoJson}
            // getAvailableDates={this.props.getAvailableDates}
            selectedMenu={this.props.selectedMenu}
            daily={this.props.data.daily}
            dateFormat={this.props.data.dateFormat}
            dateDisplayFormat={this.props.data.dateDisplayFormat}
            sliderDateFormat={this.props.data.sliderDateFormat}
            setPopupMenuSelectedStatus={this.props.setPopupMenuSelectedStatus}
            popupMenuActive={this.props.popupMenuActive}
            popupMenuSelected={this.props.popupMenuSelected}
            togglePopupMenuSelected={this.props.togglePopupMenuSelected}
            setPopupMenuStatusOnMapMenuClick={
              this.props.setPopupMenuStatusOnMapMenuClick
            }
            // handleDateChange ={this.props.handleDateChange}
            // availableDates= {this.props.availableDates}
            // date={this.props.date}
            noGraph={this.props.data.noGraph}
            setNoGraph={this.props.setNoGraph}
            disableDatePicker={this.props.disableDatePicker}
            handleTabClick={this.props.handleTabClick}
          />
        );
      });
    }

    if (subtree) {
      return (
        <div style={{ background: colors.final_side }}>
          <Menu.Item
            as="div"
            data-id={this.props.data.id}
            onClick={this.onClick}
            style={{ textAlign: "left", marginLeft: `${this.state.margin}px` }}
            disabled={this.props.data.disabled}
          >


            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "80%",
                  fontSize: !this.props.data.disabled ? "13px" : "unset",
                  color: !this.props.data.disabled ? colors.textcolor : "unset",
                  fontWeight: !this.props.data.disabled ? "bold" : "unset",
                }}
              >
             {console.log("this.props.data.displayname",this.props.data.displayname,this.props.data.name, this.props.data.active)}

                {this.props.data.displayname}
              </div>
              <div style={{ textAlign: "right", width: "20%" }}>
                {console.log(this.props.data.name, this.props.data.active)}
                {this.props.data.active ? (
                  <FontAwesomeIcon icon="angle-down" />
                ) : (
                    <FontAwesomeIcon icon="angle-right" />
                  )}
              </div>
            </div>
          </Menu.Item>

          {this.props.data.active && !this.props.data.geojson ? (
            <div
              style={{
                textAlign: "center",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor: colors.final_side_sub,
              }}
            >
              {" "}
              {this.props.data.daily ?
                <DatePicker
                  // inline
                  name="date"
                  showIcon
                    toggleCalendarOnIconClick
                    name="date"

                  value={moment(this.props.date, "DD-MM-YYYY").format(
                    "DD-MM-YYYY"
                  )}
                  onChange={(date) => this.props.handleDateChange(null, { name: 'date', value: moment(date).format('DD-MM-YYYY') })}
                  dateFormat="DD-MM-YYYY"
                  // markColor="orange"
                  placeholder="Date"
                  iconPosition="left"
                  closeOnScroll={true} // Close the calendar when scrolling
                  showMonthDropdown // Allow month selection
                  highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
        filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
        dayClassName={(date) => {
          const isEnabled = enabledDates.some(
            (enabledDate) => enabledDate.toDateString() === date.toDateString()
          );
          return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
        }}
      yearDropdownItemNumber={50}        
        closeOnSelect
        shouldCloseOnSelect={true}
        showYearDropdown
        scrollableYearDropdown 

                  minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
      
                  //enable={this.props.availableDates}
                  //markColor="teal"
                  //marked={this.props.availableDates}
                  //highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                  //includeDates={this.props.availableDates.map((date) =>
                  //  moment(date, "DD-MM-YYYY").toDate()
                  //)}
                  filterDate={(date) =>
                    enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())
                  } 
                  startMode="day"
                  pickerWidth="300px"
                  popupPosition="top right"
                  clearIcon={<Icon name="remove" color="red" />}
                /> : null}
              {this.props.data.smaienabled && this.props.weekly ?
               <div className="weekly_calendar">
                <select value={this.props.weekyearselected} selected={this.props.weekyearselected} onChange={this.props.weekYearChange}>
                  <option value="#" >Select Year</option>
                  {years}
                </select>
                <select selected={this.props.weekselected} value={this.props.weekselected} onChange={this.props.weekChange}>
                  <option value="#">Select Week</option>
                  {weeks}
                </select>
                
              </div>
              :this.props.data.smaienabled && this.props.monthly?
              
              <div className="monthly_calendar">
                <select value={this.props.monthyearselected} selected={this.props.monthyearselected} onChange={this.props.monthYearChange}>
                  <option value="#" >Select Year</option>
                  {monthYears}
                </select>
                <select selected={this.props.monthselected} value={this.props.monthselected} onChange={this.props.monthChange}>
                  <option value="#">Select Month</option>
                  {months}
                </select>
                
                </div>
                : null}
            </div>
          ) : null}
          {this.props.active ? (
            <div style={{ background: colors.final_side_sub }}>{subtree}</div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div
          style={{
            background: !this.props.data.popup
              ? colors.final_side_sub
              : colors.final_side,
            color: colors.textcolor,
            padding: "0px",
          }}
        >
          {this.props.data.name !== "#" &&
            this.props.data.name !== "Rainfall" &&
            this.props.data.name !== "Actual Evapotranspiration" &&
            this.props.data.name !== "Hydrological Science"



            ? (
              <Menu.Item
                as="div"
                data-id={this.props.data.id}
                onClick={this.onClickChild}
                style={{ textAlign: "left", color: colors.textcolor }}
                disabled={this.props.data.disabled}
              >
                <div
                  style={{
                    display: "flex",
                    padding: "0px",
                    fontSize: !this.props.data.disabled ? "13px" : "unset",
                    color: !this.props.data.disabled ? colors.text_sub_color : "unset",
                    fontWeight: !this.props.data.disabled ? "bold" : "unset",
                  }}
                >
                  {this.props.data.ismap ? (
                    <div style={{ width: "10%" }}>
                      {this.props.selectedNodeStaus[
                        this.props.parent
                          ? this.props.parent + "-" + this.props.data.name
                          : this.props.data.name
                      ] ? (
                          <FontAwesomeIcon icon="stop-circle" />
                        ) : (
                          <FontAwesomeIcon icon="circle" />
                        )}
                    </div>
                  ) : null}
                  {this.props.data.geojson ? (
                    <div style={{ width: "10%" }}>
                      {this.props.selectedNodeStaus[
                        this.props.parent
                          ? this.props.parent + "-" + this.props.data.name
                          : this.props.data.name
                      ] ? (
                          <FontAwesomeIcon icon="stop-circle" />
                        ) : (
                          <FontAwesomeIcon icon="circle" />
                        )}
                    </div>
                  ) : null}


                  <div style={{ width: "90%" }}>
                    {this.props.isForecast
                      ? moment(this.props.date, "DD-MM-YYYY")
                        .add(this.props.data.name - 1, "days")
                        .format("DD MMMM YYYY")
                      : this.props.data.displayname}
                  </div>
                </div>
              </Menu.Item>
            ) : null}
          {this.props.data.name === "#" ? this.onClickChild : null}
          {this.props.data.name === "CPC Rainfall" ? this.onClickChild : null}
          {this.props.data.name === "Actual Evapotranspiration"
            ? this.onClickChild
            : null}


        </div>
      );
    }
  }
}
